var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title"},[_c('h1',{staticClass:"content"},[_vm._v("アカウントの権限がありませんですので、管理者にご連絡してください。")])])])}]

export { render, staticRenderFns }